<template>
    <div class="account-navigate">
        <nav>
            <ul>
                <li v-for="(item, i) in navigation" :key="i" :class="{'d-block d-lg-none': item.id == 7 }">
                    <router-link :to="item.slug" :class="{'active': currentUrl === item.slug}">{{item.title}}</router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                navigation: [
                    {
                        id: 1,
                        title: 'Главная',
                        slug: '/account'
                    },
                    {
                        id: 7,
                        title: 'Новые заказы',
                        slug: '/account/new_orders'
                    },
                    {
                        id: 2,
                        title: 'Личная информация',
                        slug: '/account/personal'
                    },
                    // {
                    //     id: 3,
                    //     title: 'Реферальная ссылка',
                    //     slug: '/account/ref_link'
                    // },
                    {
                        id: 4,
                        title: 'История заказов',
                        slug: '/account/orders'
                    },
                    {
                        id: 5,
                        title: 'Карта клиента',
                        slug: '/account/card'
                    },
                    // {
                    //     id: 6,
                    //     title: 'Новая дисконтная программа',
                    //     slug: '/account/discount'
                    // }
                ],
                currentUrl: null
            }
        },

        mounted() {
            this.currentUrl = this.$route.path;
        },

        watch: {
            $route() {
                this.currentUrl = this.$route.path;
            }
        }
    }

</script>
